/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { TypeActe } from '@/types';

/** Largeur d'une `ListeTable.Column`, grille Semantic UI à 16 unités. */
type ListeTableColumnWidth =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16;

export interface ActeListeColumns {
  /** Libellé de la colonne date (ex. « Date du pacs » plutôt que « Date de l'acte »). */
  dateLabel: string;
  /** Largeur (grille 16) de la colonne date (défaut 2). */
  dateWidth?: ListeTableColumnWidth;
  /** Libellé de la colonne « Nom » à une seule personne (absent si non applicable). */
  nomLabel?: string;
  /** Libellés des colonnes à deux personnes, ex. `['Conjoint 1', 'Conjoint 2']` (absent si non applicable). */
  parentLabels?: [string, string];
}

const DEFAULT_ACTE_LISTE_COLUMNS: ActeListeColumns = {
  dateLabel: "Date de l'acte",
  nomLabel: 'Nom',
};

/**
 * Libellés des colonnes de la liste générique d'actes (`ActeListeTable`,
 * utilisée dans les modales de la vue synthétique du dashboard), par type
 * d'acte : chaque type d'acte a son propre vocabulaire métier pour les mêmes
 * colonnes (date, personne(s) concernée(s)).
 */
const ACTE_LISTE_COLUMNS: Partial<Record<TypeActe, ActeListeColumns>> = {
  naissance: DEFAULT_ACTE_LISTE_COLUMNS,
  // La reconnaissance affiche À LA FOIS l'enfant (`nomLabel`) et les 2 parents
  // qui reconnaissent (`parentLabels`), contrairement aux autres types qui
  // n'affichent que l'un ou l'autre.
  reconnaissance: {
    dateLabel: "Date de l'acte",
    nomLabel: 'Enfant',
    // Une reconnaissance est faite par un père et/ou une mère : les colonnes
    // `ar_per_*` / `ar_mer_*` portent déjà ce rôle en base.
    parentLabels: ['Père', 'Mère'],
  },
  mariage: {
    dateLabel: "Date de l'acte",
    parentLabels: ['Conjoint 1', 'Conjoint 2'],
  },
  pacs: {
    dateLabel: 'Date du pacs',
    parentLabels: ['Partenaire 1', 'Partenaire 2'],
  },
  deces: {
    dateLabel: "Date de l'acte",
    nomLabel: 'Défunt',
  },
  decision: {
    dateLabel: 'Date de la décision',
    dateWidth: 3,
    nomLabel: 'Demandeur',
  },
};

export const getActeListeColumns = (typeActe?: string): ActeListeColumns =>
  (typeActe && ACTE_LISTE_COLUMNS[typeActe as TypeActe]) ||
  DEFAULT_ACTE_LISTE_COLUMNS;

export default ACTE_LISTE_COLUMNS;
